var FreeShipping;

FreeShipping = window.FreeShipping != null ? window.FreeShipping : window.FreeShipping = {};

FreeShipping.View = require('./views/free_shipping');

FreeShipping.init = function(arg, done) {
  var shippingDetails;
  shippingDetails = arg.shippingDetails;
  if (!shippingDetails) {
    return done();
  }
  return $(function() {
    var view;
    view = new FreeShipping.View({
      el: '.free-shipping-container',
      freeShippingValues: shippingDetails
    });
    return done();
  });
};

module.exports = FreeShipping;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9zaGlwcGluZy9mcm9udGVuZC9mcmVlX3NoaXBwaW5nLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvc2hpcHBpbmcvZnJvbnRlbmQvZnJlZV9zaGlwcGluZy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxZQUFBLGlDQUFlLE1BQU0sQ0FBQyxlQUFQLE1BQU0sQ0FBQyxlQUFnQjs7QUFFdEMsWUFBWSxDQUFDLElBQWIsR0FBb0IsT0FBQSxDQUFRLHVCQUFSOztBQUVwQixZQUFZLENBQUMsSUFBYixHQUFvQixTQUFDLEdBQUQsRUFBb0IsSUFBcEI7QUFDbEIsTUFBQTtFQURvQixrQkFBRDtFQUNuQixJQUFBLENBQXFCLGVBQXJCO0FBQUEsV0FBTyxJQUFBLENBQUEsRUFBUDs7U0FDQSxDQUFBLENBQUUsU0FBQTtBQUNBLFFBQUE7SUFBQSxJQUFBLEdBQU8sSUFBSSxZQUFZLENBQUMsSUFBakIsQ0FDTDtNQUFBLEVBQUEsRUFBSSwwQkFBSjtNQUNBLGtCQUFBLEVBQW9CLGVBRHBCO0tBREs7V0FJUCxJQUFBLENBQUE7RUFMQSxDQUFGO0FBRmtCOztBQVVwQixNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
